import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import SkeletonScreenComponent from 'webapp/components/skeleton-screen';

import { settingsNamePrefix } from 'webapp/models-custom/filter-sort/board';

export default class BoardsIndexLoadingRouteTemplate extends Component {
	@service('account') declare accountService: Service.Account;
	@service('view-settings-manager')
	declare viewSettingsManagerService: Service.ViewSettingsManager;

	get viewId(): string {
		const settingsName = `${settingsNamePrefix}-${this.accountService.id}`;
		const filterSettings =
			this.viewSettingsManagerService.load<{ viewId: string }>(settingsName, true) || {};
		return filterSettings.viewId || 'grid';
	}

	get skeletonScreenType() {
		return this.viewId === 'grid' ? 'tiles' : 'table';
	}

	<template><SkeletonScreenComponent @type={{this.skeletonScreenType}} @item="board" /></template>
}
